import { usePermissions } from '@procureai/permissions-ui';
import { useMemo } from 'react';

import { getSearchDomainPermission } from '../../config/searchIndex/searchIndex.ts';
import { SearchDomain, searchDomains } from '~/routes/Search/types/SearchDomain.ts';

interface UseSearchDomainsResult {
  searchDomains: SearchDomain[];
}

export const useSearchDomains = (): UseSearchDomainsResult => {
  const { hasPermission } = usePermissions();

  return useMemo<UseSearchDomainsResult>(() => {
    return {
      searchDomains: searchDomains.filter((domain) => hasPermission(getSearchDomainPermission(domain))),
    };
  }, [hasPermission]);
};
